import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/explore/components/POIDetailsLink/POIDetailsLink.tsx");
